import React, { useContext, useEffect, useState } from "react";
import MerchantLayout from "../../layout/MerchantLayout";
import "./subscription.css";
import { SubscriptionInfo, UserInfo } from "../../../context";
import { Button, Col, Modal, Row, Typography } from "antd";
import moment from "moment";
import CurrentSubscription from "./CurrentSubscription";
import { useNavigate } from "react-router-dom";

const MerchantSubscription = () => {
  var timer;
  const { subscriptionDetails } = useContext(SubscriptionInfo);
  const [days, setDays] = useState(null);
  const [hours, setHours] = useState(null);
  const [minutes, setMinutes] = useState(null);
  const [seconds, setSeconds] = useState(null);
  const dateNow = moment(new Date()).format("YYYY-MM-DD HH:mm:ss");
  const { handleLogoutTkn } = useContext(UserInfo);
  const navigate = useNavigate();

  function timeBetweenDates(expiry) {
    var dateExpiry = expiry;
    var dateNow = new Date();
    var difference = dateExpiry.getTime() - dateNow.getTime();

    if (difference <= 0) {
      setDays(0);
      setHours(0);
      setMinutes(0);
      setSeconds(0);

      clearInterval(timer);
    } else {
      var seconds = Math.floor(difference / 1000);
      var minutes = Math.floor(seconds / 60);
      var hours = Math.floor(minutes / 60);
      var days = Math.floor(hours / 24);

      hours %= 24;
      minutes %= 60;
      seconds %= 60;

      setDays(days);
      setHours(hours);
      setMinutes(minutes);
      setSeconds(seconds);
    }
  }

  const getCalculateSubscription = () => {
    var comparedDate = new Date(subscriptionDetails.data.plan_expiry);
    timer = setInterval(function () {
      timeBetweenDates(comparedDate);
    }, 1000);
  };

  useEffect(() => {
    getCalculateSubscription();
    return () => {
      clearInterval(timer);
    };
  }, []);

  return (
    <MerchantLayout>
      <Row>
        <Col
          xs={24}
          sm={24}
          md={12}
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100%",
            minHeight: window.innerWidth > 767 ? window.innerHeight - 230 : 220,
          }}
        >
          <div style={{ height: "100%", width: "100%" }}>
            {subscriptionDetails.ready && (
              <div style={{ width: "100%" }}>
                <div
                  style={{
                    border: "1px solid #e5e5e5",
                    borderStyle: "dashed",
                    width: "100%",
                  }}
                >
                  <div
                    id="timer"
                    style={{
                      textAlign: "center",
                    }}
                  >
                    <span id="days">{days}</span>
                    days
                  </div>

                  <div
                    id="timer"
                    style={{
                      textAlign: "center",
                    }}
                  >
                    <span id="hours">{hours}</span>hrs
                    <span id="minutes">{minutes}</span>mins
                    <span id="seconds">{seconds}</span>secs
                  </div>
                </div>

                {/* {console.log("days", days)} */}

                {days <= 15 && days !== null && days !== 0 && (
                  <div style={{ marginTop: 20 }}>
                    <Typography style={{ marginBottom: 10 }}>
                      <span style={{ fontWeight: "bold" }}>Subject:</span>{" "}
                      Subscription Renewal Reminder
                    </Typography>
                    <Typography style={{ marginBottom: 10 }}>
                      Dear Merchant,
                    </Typography>
                    <Typography>
                      This is a friendly reminder that your subscription to the
                      Software(DigiMenu) is expiring soon. To continue enjoying
                      uninterrupted access and benefits, please renew your
                      subscription before{" "}
                      <span style={{ fontWeight: "bold" }}>
                        {moment(subscriptionDetails.data.plan_expiry).format(
                          "MMM. DD, YYYY"
                        )}
                      </span>
                      .
                    </Typography>
                    <Typography>
                      Renew Your Subscription Now with this button below or just
                      click this{" "}
                      <a
                        style={{
                          textDecoration: "underline",
                          fontWeight: "bold",
                        }}
                        onClick={() => navigate("/renew-subscription")}
                      >
                        link.
                      </a>
                    </Typography>
                    <Typography style={{ marginBottom: 10 }}>
                      We appreciate your continued support and look forward to
                      serving you in the coming subscription term.
                    </Typography>
                    <Typography>Best regards,</Typography>
                    <Typography style={{ fontWeight: "bold" }}>
                      DigiMenu Team
                    </Typography>
                    <Typography style={{ fontWeight: "bold" }}>
                      Nehemiah Solutions
                    </Typography>

                    <Button
                      className="gradientbtn"
                      onClick={() => navigate("/renew-subscription")}
                    >
                      Renew Now
                    </Button>
                  </div>
                )}
              </div>
            )}
          </div>
        </Col>
        <Col
          xs={24}
          sm={24}
          md={12}
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            height: "100%",
            minHeight: window.innerWidth > 767 ? window.innerHeight - 230 : 220,
          }}
        >
          {/* <div
            style={{
              display: "flex",
              justifyContent: "center",
              border: "1px solid red",
              minWidth: 320,
            }}
          > */}
          <CurrentSubscription
            subscription={subscriptionDetails.data.current_plan}
            // subscription="basic"
          />
          {/* </div> */}
        </Col>
      </Row>

      {/* {console.log("dateNow", dateNow)}
      {console.log("plan_expiry", subscriptionDetails.data.plan_expiry)} */}

      <Modal
        title="Subscription has ended."
        centered
        open={dateNow >= subscriptionDetails.data.plan_expiry}
        // open={true}
        footer={null}
        width={350}
        closable={false}
      >
        <div style={{ display: "flex" }}>
          <div style={{ flexGrow: 1 }} />
          <Button
            style={{ marginRight: 5 }}
            onClick={() => navigate("/renew-subscription")}
          >
            Renew
          </Button>
          <Button type="primary" onClick={() => handleLogoutTkn()}>
            Logout
          </Button>
        </div>
      </Modal>
    </MerchantLayout>
  );
};

export default MerchantSubscription;
